/**
 * Zwraca jsx dla Img1 i Img2 dla danego wyrazu
 */
import React from 'react';
import { staticsUrl } from '../../../config';

function Imgs(props) {
  const { data, img1Ref, img2Ref } = props;
  const { mainImg, secondaryImg } = data;

  const img1Style = {
    position: 'absolute',
    opacity: 0,
    top: mainImg.y,
    left: mainImg.x,
  };

  const img2Style = {
    position: 'absolute',
    opacity: 0,
    top: secondaryImg.y,
    left: secondaryImg.x,
  };

  const img1 = <img
    src={staticsUrl + mainImg.url}
    style={img1Style}
    alt=""
    ref={img1Ref}
  />

  let img2 = '';

  if (secondaryImg) {
    img2 = <img
      src={staticsUrl + secondaryImg.url}
      style={img2Style}
      alt=""
      ref={img2Ref}
    />
  }

  return <>{img1}{img2}</>;
}

export default Imgs;
